import initialMetricsPublisher from 'src/metrics';
import * as KatalMetrics from '@amzn/katal-metrics';

export const publishKendraQuery = (userId: string, query: string) => {
    const metricsPublisher =
        initialMetricsPublisher.newChildActionPublisherForMethod('KendraQuery');
    metricsPublisher.publish(
        new KatalMetrics.Metric.String('kendra.query', query)
    );
    metricsPublisher.publish(
        new KatalMetrics.Metric.String('kendra.userId', userId)
    );
};

export const publishKendraClickThrough = (
    userId: string,
    query: string,
    documentId: string,
    resultPosition: number,
    topicId: string,
    topicName: string
) => {
    const metricsPublisher =
        initialMetricsPublisher.newChildActionPublisherForMethod(
            'KendraClickThrough'
        );
    metricsPublisher.publish(
        new KatalMetrics.Metric.String('kendra.query', query)
    );
    metricsPublisher.publish(
        new KatalMetrics.Metric.String('kendra.userId', userId)
    );
    metricsPublisher.publish(
        new KatalMetrics.Metric.String('kendra.documentId', documentId)
    );
    metricsPublisher.publish(
        new KatalMetrics.Metric.String(
            'kendra.resultPosition',
            String(resultPosition)
        )
    );
    metricsPublisher.publish(
        new KatalMetrics.Metric.String('kendra.topicId', topicId)
    );
    metricsPublisher.publish(
        new KatalMetrics.Metric.String('kendra.topicName', topicName)
    );
};

export const publishKendraNoResults = (userId: string, query: string) => {
    const metricsPublisher =
        initialMetricsPublisher.newChildActionPublisherForMethod(
            'KendraNoResults'
        );
    metricsPublisher.publish(
        new KatalMetrics.Metric.String('kendra.query', query)
    );
    metricsPublisher.publish(
        new KatalMetrics.Metric.String('kendra.userId', userId)
    );
};

export const publishKendraError = (
    userId: string,
    query: string,
    error: string
) => {
    const metricsPublisher =
        initialMetricsPublisher.newChildActionPublisherForMethod('KendraError');
    metricsPublisher.publish(
        new KatalMetrics.Metric.String('kendra.query', query)
    );
    metricsPublisher.publish(
        new KatalMetrics.Metric.String('kendra.userId', userId)
    );
    metricsPublisher.publish(
        new KatalMetrics.Metric.String('kendra.error', error)
    );
};
